import isEmpty from '../isEmpty';

const required = (value: string, message?: string): string | undefined => {
  return isEmpty(value) ? (message ? message : 'This field is required.') : undefined;
};

export default required;
